import React from "react";
import { Link } from "react-router-dom";
import services from "../data/services";

function Services() {
  return (
    <>
      <section className=" inner-banner-sec service_page">
        <div className="container-fluid add-padding-2">
          <div
            className="inner-bg-img"
            style={{
              backgroundImage:
                "url('images/service-banner.jpg')",
            }}
          >
            <div className="row">
              <div className="col-12 align-self-center">
                <div className="banner_text">
                  <h1>
                    <span>Services</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="service-sec inner-servicer-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-12">
              <div className="service-heading">
                <h2>Our Services</h2>
              </div>
            </div>

            {services.map((service, index) => (
              <div
                className="col-xl-4 col-lg-4 col-md-6 col-sm-9 col-12"
                key={service.id}
              >
                <div className="service-box">
                  <div className="service-text">
                    <h5>{String(index + 1).padStart(2, "0")}</h5>
                    <h4>{service.title}</h4>
                    <p>{service.desc}</p>
                    <Link
                      to={`/service-detail/${service.id}`}
                      className="theme-btn-1"
                    >
                      <span>More Detail</span>
                    </Link>
                  </div>
                  <div className="service-img">
                    <img src={service.img} alt={service.title} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
